import React from 'react';
import PropTypes from 'prop-types';
import './PageContainer.scss';

const PageContainer = ({children, className, ...props}) => (
  <div className={`page-container ${className}`} {...props}>
    {children}
  </div>
);

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageContainer;
